import moment from '@/plugins/vue-moment.js';

class ActivityHelper {
    getSectionDueDates(item, rootGetters, template) {
        const settings = item.type.includes('temp') ? 'section_settings_template' : 'section_settings';
        const setting_namespace = settings.includes('temp') ? 'SectionTemplates' : 'Sections';
        const timezone = rootGetters['InstitutionSettings/get']('timezone');

        if (item.parent_id) {
            const parent = rootGetters[`${setting_namespace}/getByKey`]({
                keyName: 'id',
                key: Number(item.parent_id),
            });

            if (!parent.parent_id) {
                if (!template) {
                    return {
                        type: parent.sectionType,
                        week: {
                            start: this.formatDate(parent[settings].week_start, timezone),
                            end: this.formatDate(parent[settings].week_end, timezone),
                        },
                    };
                }

                return {
                    type: parent.sectionType,
                    week: parent[settings].week_number,
                };
            }

            return this.getSectionDueDates(parent, rootGetters, template);
        }

        return template
            ? { type: item.sectionType, week: item[settings].week_number }
            : {
                  type: item.sectionType,
                  week: {
                      start: this.formatDate(item[settings].week_start, timezone),
                      end: this.formatDate(item[settings].week_end, timezone),
                  },
              };
    }

    formatDate(date, timezone) {
        if (!timezone) {
            throw new Error('Timezone must be present in order to format the date.');
        }

        return moment.utc(date).tz(timezone).toDate();
    }

    /**
     * Determine whether a store activity is a remediation activity belonging to the given course.
     *
     * The remediation getter runs this over the entire shared activities collection, which can
     * contain partially-hydrated entries (e.g. left in the store by the gradebook) whose `type`
     * discriminator or settings are still null. Guard against those so a single malformed entry
     * cannot crash the Remediation Activities modal.
     *
     * @param {{type?: string|null}} activity
     * @param {number} id course id (or course template id for templates)
     * @returns {boolean}
     */
    isRemediationActivity(activity, id) {
        if (!activity?.type) {
            return false;
        }

        const template = activity.type.includes('template');
        const settingKey = template ? 'activity_settings_template' : 'activity_settings';
        const courseIdKey = template ? 'course_template_id' : 'course_id';

        return Boolean(activity[settingKey]?.is_remediation) && activity[courseIdKey] === id;
    }
}

export default ActivityHelper;
